import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-extended-alert-dialog',
  templateUrl: './extended-alert-dialog.component.html',
  styleUrls: ['./extended-alert-dialog.component.scss'],
  standalone: false
})
export class ExtendedAlertDialogComponent {
  data = inject<{
    header: string;
    textArray: string[];
    translate: boolean;
  }>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<ExtendedAlertDialogComponent>>(MatDialogRef);

  header: string = '';
  textArray: string[] = [];
  translate: boolean = false;


  constructor() {
    const data = this.data;

    this.header = data.header || this.header;
    this.textArray = data.textArray || this.textArray;
    this.dialogRef.disableClose = false;
    this.dialogRef.updateSize('300vw');
    this.translate = data.translate || this.translate;
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
